module.exports = __webpack_public_path__ + "static/media/UniversityofAberdeen.fe43fc43.png";